// extracted by mini-css-extract-plugin
export var readonly = "_g2-1";
export var star = "_g2-0";